<rask-kontrakt-header [entity]="entity()"></rask-kontrakt-header>

<rask-skogsvard-list></rask-skogsvard-list>

<rask-kontrakt-certifiering [kontrakt]="entity()"></rask-kontrakt-certifiering>

<rask-kontrakt-utskrift
    *raskPermitted="[{ role: 'RASK.Kopplanera', canView: false }]; merge: true">
</rask-kontrakt-utskrift>
<rask-kontrakt-utskrift-dokument></rask-kontrakt-utskrift-dokument>
<rask-kontrakt-bilagor [kontraktId]="kontrakt.id" [readonly]="kontraktReadonly"></rask-kontrakt-bilagor>